/*
 * Copyright (c) 2024 metromorph softworks GmbH
 *
 * All rights reserved
 */

import * as React from "react";

import Container from "@mui/material/Container";

import { Logo } from "@ef/theme-basic";

export default function WaitContainer({children = null} : { readonly children?: React.ReactNode }) {
    return (
        <Container 
            sx={{
                textAlign: "center",
                paddingTop: 10 
            }}
        >
            <Logo loading={true} />
            {children}
        </Container>
    );
}
